module.exports = __webpack_public_path__ + "media/images/main-visual-e00d2eb9d00fbd034c0fbea1c54f9d70.jpg";